// extracted by mini-css-extract-plugin
export default {"btop":"_705242362a _38ad7fd271 _3eb20ee91e","icon":"e3dd7e3004 _6ebcf1ee5e","btoppink":"eefbf35ebc _376a5570d3"};